module.exports = __webpack_public_path__ + "img/op_img-carrusel-personas-1.0520205.jpg";